import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { findThemeIdInRoute } from '@tokenbox/services';
import { ANY_THEME_WILDCARD } from './guards/theme.guard.ts';
import { SelectedThemeService } from './selected-theme.service.ts';

@Injectable({
  providedIn: 'root',
})
export class SelectedThemeGuard {
  private selectedThemeService = inject(SelectedThemeService);

  async canActivate(route: ActivatedRouteSnapshot) {
    const themeIdByRoute = findThemeIdInRoute(route);
    if (themeIdByRoute !== ANY_THEME_WILDCARD) {
      this.selectedThemeService.selectedThemeId.set(themeIdByRoute);
    }
    return true;
  }
}
